// Unsent GPS points survive reload in this tab, never persist across browser sessions.
const LEGACY = 'sahakar_trip_breadcrumb_queue_v2';
const key = (userId) => `sahakar_trip_queue:${userId}`;
export function loadTripQueue(userId) {
  if (!userId) return {};
  try { return JSON.parse(sessionStorage.getItem(key(userId)) || '{}'); } catch { return {}; }
}
export function saveTripQueue(userId, queue) {
  if (!userId) return;
  try { sessionStorage.setItem(key(userId), JSON.stringify(queue)); } catch { /* memory remains available */ }
}
export function migrateTripQueue(userId, activeIds, queue) {
  // Only claim legacy points after the server identifies this user's active trips.
  try {
    const legacy = JSON.parse(localStorage.getItem(LEGACY) || '{}');
    for (const id of activeIds) if (Array.isArray(legacy[id]) && !queue[id]) queue[id] = legacy[id];
  } catch { /* malformed/blocked storage */ }
  try { localStorage.removeItem(LEGACY); } catch { /* blocked storage */ }
  saveTripQueue(userId, queue);
  return queue;
}
export function clearTripQueue(userId) {
  try { sessionStorage.removeItem(key(userId)); } catch { /* blocked storage */ }
}

export function clearAllTripQueues() {
  try {
    for (const name of Object.keys(sessionStorage)) if (name.startsWith('sahakar_trip_queue:')) sessionStorage.removeItem(name);
    localStorage.removeItem(LEGACY);
  } catch { /* blocked storage */ }
}